import styled from "styled-components";

interface Props {
  label: string;
  value: string;
  hint?: string;
  tone?: "default" | "positive" | "negative" | "neutral";
}

const ReportMetricCard: React.FC<Props> = ({
  label,
  value,
  hint,
  tone = "default",
}) => {
  return (
    <Card $tone={tone}>
      <Label>{label}</Label>
      <Value $tone={tone}>{value}</Value>
      {hint && <Hint>{hint}</Hint>}
    </Card>
  );
};

export default ReportMetricCard;

type Tone = "default" | "positive" | "negative" | "neutral";

const Card = styled.div<{ $tone: Tone }>`
  background: #ffffff;
  border: 1px solid ${({ theme }) => theme.palette.primitives.gray200};
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primitives.gray600};
`;

const Value = styled.div<{ $tone: Tone }>`
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: ${({ theme, $tone }) => {
    switch ($tone) {
      case "positive":
        return theme.palette.primitives.green600;
      case "negative":
        return theme.palette.foundation.negative;
      case "neutral":
        return theme.palette.primitives.gray700;
      default:
        return theme.palette.foundation.primaryA;
    }
  }};
`;

const Hint = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primitives.gray500};
`;
